import ScrollReveal from '../ScrollReveal';
import { t } from '@/data/translations';
import type { Lang } from '@/pages/Index';
import type { ExperienceData } from '@/data/translations';

interface ExperienceItemProps extends ExperienceData {
  delay?: number;
}

const ExperienceItem = ({ period, role, company, location, mission, activities, valueAdded, delay = 0 }: ExperienceItemProps) => (
  <ScrollReveal delay={delay}>
    <article className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-12 border-t border-border">
      <div className="md:col-span-3">
        <p className="text-sm md:text-base text-muted-foreground">{period}</p>
      </div>
      <div className="md:col-span-9">
        <h3 className="text-xl md:text-2xl font-medium text-foreground mb-2">{role}</h3>
        <p className="text-base md:text-lg text-muted-foreground mb-4">{company} — {location}</p>
        {mission && <p className="text-base md:text-lg text-foreground/90 mb-4 font-medium">{mission}</p>}
        <ul className="space-y-2 mb-4">
          {activities.map((activity, index) => (
            <li key={index} className="list-item-hover text-base md:text-lg text-muted-foreground/80 leading-relaxed pl-5 relative before:content-['–'] before:absolute before:left-0 before:text-primary/40">
              {activity}
            </li>
          ))}
        </ul>
        {valueAdded && (
          <p className="text-sm md:text-base text-muted-foreground/70 italic mt-6 max-w-xl">{valueAdded}</p>
        )}
      </div>
    </article>
  </ScrollReveal>
);

const Experience = ({ lang }: { lang: Lang }) => {
  const tr = t(lang).experience;
  return (
    <section id="experience" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-card">
      <div className="max-w-4xl mx-auto">
        <ScrollReveal>
          <div className="section-divider mb-8" />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <h2 className="text-sm tracking-widest uppercase text-muted-foreground mb-12">{tr.sectionTitle}</h2>
        </ScrollReveal>
        <div>
          {tr.items.map((exp, index) => (
            <ExperienceItem key={index} {...exp} delay={(index + 1) * 100} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
